import { createAsyncThunk } from '@reduxjs/toolkit';
import { WebformStateCondition, getSavedConditions } from '@qodly/shared';
import { AppState } from '..';

export const fetchSavedConditions = createAsyncThunk<
  WebformStateCondition[],
  void,
  {
    state: AppState;
    rejectValue: string;
  }
>(
  'saved_conditions/fetchSavedConditions',

  async (_, { rejectWithValue }) => {
    try {
      const { conditions = [] } = await getSavedConditions({
        createIfNotExists: true,
      });

      return conditions;
    } catch (e) {
      return rejectWithValue('Error while loading the shared conditions');
    }
  },
);
